import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ArrowRight = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7 11.2L12.7 6.2C12.3 5.8 11.7 5.8 11.3 6.2C10.9 6.6 10.9 7.2 11.3 7.6L14.6 10.9H7C6.4 10.9 6 11.3 6 11.9C6 12.5 6.4 12.9 7 12.9H14.6L11.3 16.2C10.9 16.6 10.9 17.2 11.3 17.6C11.7 18 12.3 18 12.7 17.6L17.7 12.6C18.1 12.3 18.1 11.6 17.7 11.2Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowRight
